import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import ReportProblemRoundedIcon from "@material-ui/icons/ReportProblemRounded";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { PER_TIER_KYC_COPY } from "./PerTierKyc.constants";

export const KycConfirmDialog = ({
  open,
  acknowledged = false,
  confirming = false,
  onAckChange,
  onBack,
  onConfirm,
}) => (
  <ExlyModal
    open={open}
    onClose={onBack}
    title={
      <div className="tw-flex tw-items-center">
        <ReportProblemRoundedIcon htmlColor="#BF2600" className="tw-mr-2" />
        {PER_TIER_KYC_COPY.CONFIRM_TITLE}
      </div>
    }
    modal_props={{
      footerClassName: "!tw-justify-between",
    }}
    primaryBtnText={PER_TIER_KYC_COPY.CONFIRM_ACTION}
    onPrimaryBtnClick={onConfirm}
    primaryBtnProps={{ disabled: !acknowledged || confirming }}
    secondaryBtnText={PER_TIER_KYC_COPY.GO_BACK}
    onSecondaryBtnClick={onBack}
    showSecondaryBtn
  >
    <div className="tw-py-4 tw-flex tw-flex-col tw-gap-4">
      <div className="tw-text-sm">{PER_TIER_KYC_COPY.CONFIRM_BODY}</div>
      <label className="tw-flex tw-items-start tw-gap-2 tw-cursor-pointer">
        <Checkbox
          checked={acknowledged}
          onChange={(event) => onAckChange?.(event.target.checked)}
          color="primary"
        />
        <span className="tw-text-sm tw-mt-2">
          {PER_TIER_KYC_COPY.CONFIRM_ACK}
        </span>
      </label>
    </div>
  </ExlyModal>
);
